import ethereum from 'decentralized/ethereum.js';

export function splitIntoBytes32(str) {
    str = stripHexPrefix(str);
    let size = 64;
    let list = [];
    for (let i=0; i < str.length; i+=size) {
        if (str.length < i + size) {
            list.push(padRight('0x' + str.slice(i)));
        } else {
            list.push(padRight('0x' + str.slice(i, i + size)));
        }
    }
    
    return list;
}

function stripHexPrefix(str) {
    if (str.indexOf('0x') === 0) {
        return str.slice(2);
    } else {
        return str;
    }
}

function padRight(str) {
    return ethereum.web3.utils.padRight(str, 64);
}

